import { TipoItem, Udm, Moneda } from "../../../isp.žapi.servicios/constantesApiServicios";

const tiposItem = [
    { label: "Plan de Internet", value: TipoItem.PlanInternet },
    { label: "Servicios Gener.", value: TipoItem.ServiciosGen },
    { label: "Articulo", value: TipoItem.Articulo },
];

const udms = [
    { label: "Mensual", value: Udm.Mensual },
    { label: "Unidad", value: Udm.Unidad },
];

const monedas = [
    { label: "Soles (S/)", value: Moneda.Soles },
    { label: "Dólares ($)", value: Moneda.Dolares },
];

const tiposComprobantesCombo = [
    { label: "Recibo de Venta", value: "rv" },
    { label: "Factura", value: "fac" },
    { label: "Boleta", value: "bol" },
];
const ciclosFactCombo = [
    { label: "15 del mes", value: "15m" },
    { label: "Último dia del mes", value: "udiam" },
];

export { tiposComprobantesCombo, ciclosFactCombo, tiposItem, udms, monedas };
